import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import RooftopSolar from "./components/RooftopSolar/RooftopSolar";
import PMKusumSolar from "./components/PMKusumSolar/PMKusumSolar";
import CaptiveModel from "./components/CaptiveModel/CaptiveModel";
import OpenAccessSolar from "./components/OpenAccessSolar/OpenAccessSolar";
import GroupCaptive from "./components/GroupCaptive/GroupCaptive";
import ResidentialRooftop from "./components/ResidentialRooftop/ResidentialRooftop";
import CarbonCredits from "./components/CarbonCredits/CarbonCredits";
import CommercialRooftop from "./components/CommercialRooftop/CommercialRooftop";
import TrueTrack from "./components/TrueTrack/TrueTrack";
import TrueCom from "./components/TrueCom/TrueCom";
import TrueCare from "./components/TrueCare/TrueCare";
import ScrollToTop from "./components/ScrollToTop";
import ContactUs from "./components/ContactUs/ContactUs";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import AboutUs from "./components/AboutUs/AboutUs";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rooftop-solar" element={<RooftopSolar />} />
        <Route path="/captive-model" element={<CaptiveModel />} />
        <Route path="/open-access" element={<OpenAccessSolar />} />
        <Route path="/group-captive" element={<GroupCaptive />} />
        <Route path="/pm-kusum" element={<PMKusumSolar />} />
        <Route path="/residential-rooftop" element={<ResidentialRooftop />} />
        <Route path="/carbon-credits" element={<CarbonCredits />} />
        <Route path="/commercial-rooftop" element={<CommercialRooftop />} />
        <Route path="/truetrack" element={<TrueTrack />} />
        <Route path="/truecom" element={<TrueCom />} />
        <Route path="/truecare" element={<TrueCare />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/about" element={<AboutUs />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;